module.exports = __webpack_public_path__ + "assets/img/Advanced.tit.860179f3.png";